<template>
    <div>
        <div class="relative h-50px rounded-10 bg-white">
            <div class="p-0 relative"
            :class="{'datepicker-custom-right': isRight}">
                <label @click="openInputCalendar()" class="z-0 block absolute px-3.5 text-a-brown-9f8273 duration-300"
                     :class="[classTextLabel]">
                     <span v-if="inputLbl.required" class="text-a-red-d62300">*</span>{{inputLbl.name}}
                </label>
                <Datepicker class=" icon-calendar-bg w-full h-50px rounded-10 border border-a-brown-d7c7b8 text-a-brown-502314 text-14 px-3.5 pt-6 pb-2 bg-transparent"
                        ref="date-picker"
                        v-model="pickedDate"
                        :weekStartsOn="0"
                        :lowerLimit="lowerLimit"
                        :upperLimit="upperLimit"
                        :locale="localeDate"
                        :inputFormat="dateFormat"
                        :disabled="isDisabled"
                        @update:modelValue="onSelectDate()"
                ></Datepicker>
            </div>
            <!-- error msg -->
            <div class="text-red-500 text-sm absolute bottom-0 left-0 w-full" v-if="isError">
                {{getErrorMsg}}
            </div>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import DatetimeHelper from '@/helper/DatetimeHelper';
//lib
import Datepicker from 'vue3-datepicker' //https://icehaunter.github.io/vue3-datepicker/#example
import { th, enUS } from 'date-fns/locale'
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Date} lowerLimit (optional) date before can not select.
 * @property {Date} upperLimit (optional) date after can not select.
 * @property {Boolean} isDisabled (optional) disable input
 * @property {String} dateFormat (optional) date format
 * @property {Object} inputLbl (required) label for input
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 */
export default {
    name: 'InputCalendar',
    mixins: [LocaleMixin],
    components:{
        Datepicker,
    },
    props:{
        inputValue:  { type: [String, Date, Number], default: '' },

        lowerLimit:  { type: Date, default: null },
        upperLimit:  { type: Date, default: null },
        isDisabled:  { type: Boolean, default: false },
        dateFormat:  { type: String, default: 'dd/MM/yyyy' },

        inputLbl:    { type: Object, required: true },
        errorInfo:   { type: Object, default: null },
        isShowError: { type: Boolean, default: false },
        isSubmitted: { type: Boolean, default: false },
        isRight :    { type: Boolean, default: false },
    },
    data: function() {
        return {
            pickedDate: null,
            currentDate: new Date(),
            localeDate: null,

            textDateShow: '',
        };
    },
    created: function() {
        if (this.localeCode == 1033) {
            this.localeDate = enUS;
        } else {
            this.localeDate = th;
        }
        // this.pickedDate = this.inputValue
        this.initInput();
    },
    mounted: function() {
        this.validateInput();
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            if (this.isShowError && this.isSubmitted && !this.errorInfo.isValid) {
                return this.errorInfo.msg
            }
            return '';
        },
        classTextLabel: function () {
            if (this.pickedDate == null) {
                return 'top-3.5 px-3.5 text-14';
            }
            return 'top-1.5  text-12';
        },
    },
    methods: {
        openInputCalendar: function () {
            console.log(this.$refs['date-picker'].$el);
            this.$refs['date-picker'].$el.click();
        },
        initInput: function() {
            if (Util.isEmptyStr(this.inputValue)) {
                // this.pickedDate = new Date();
                return;
            }

            let date = null;
            let checkDate = this.inputValue.toString();

            if (this.inputValue instanceof Date) {
                date = this.inputValue;
            } else if (checkDate.match(/^-{0,1}[0-9]+$/)) {
                date = DatetimeHelper.unixTimestampToDate(this.inputValue);
            } else {
                date = DatetimeHelper.stringToDate(this.inputValue, 'YYYY-MM-DD');
            }

            this.pickedDate = date;
        },
        onSelectDate: function() {
            this.validateInput();
            let inputDate = this.pickedDate;
            let timestamp = DatetimeHelper.convertDateToTimeStampUnix(inputDate);
            let formated = DatetimeHelper.dateIsoFormat(inputDate);
            let value = {
                date: inputDate,
                timestamp: timestamp,
                formated: formated,
            };

            this.textDateShow = formated;

            this.$emit('update:inputValue', inputDate);
            this.$emit('onDateChange', value);
        },

        validateInput: function() {
            if (Util.isEmptyStr(this.inputLbl.required) || this.pickedDate != null) {
                this.errorInfo.setValid(true);
                return true;
            } else {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required);
                return false;
            }
        },
    },
}
</script>
<style lang="scss">
    .datepicker-custom-right {
        .v3dp__popout {
            right: 0;
        }
    }
</style>
<style lang="scss">
    .icon-calendar-bg {
        background-color: transparent;
        background-image: url('../../../assets/input/Calendar.svg');
        background-repeat: no-repeat;
        background-size: 24px;
        background-position-x: calc(100% - 12px);
        background-position-y: 12px;
    }
</style>
